/** Max characters of a selected fragment that is kept as quoted context. */
export const MAX_QUOTE_LENGTH = 2000;

export function normalizeQuote(raw: string): string {
  const text = raw.replace(/\r\n?/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
  return text.length > MAX_QUOTE_LENGTH ? `${text.slice(0, MAX_QUOTE_LENGTH).trimEnd()}…` : text;
}

/** Builds message text that carries the quoted fragment as a markdown blockquote. */
export function formatQuotedMessage(quote: string | null | undefined, text: string): string {
  const q = quote ? normalizeQuote(quote) : '';
  if (!q) return text;
  const block = q.split('\n').map((line) => (line ? `> ${line}` : '>')).join('\n');
  return `${block}\n\n${text}`;
}

/** Splits a leading blockquote (created by formatQuotedMessage) from the message body. */
export function parseQuotedMessage(content: string): { quote: string | null; body: string } {
  const lines = content.split('\n');
  let i = 0;
  while (i < lines.length && /^>( |$)/.test(lines[i]!)) i += 1;
  if (i === 0 || (i < lines.length && lines[i] !== '')) return { quote: null, body: content };
  const quote = lines.slice(0, i).map((line) => line.slice(2)).join('\n');
  return { quote, body: lines.slice(i + 1).join('\n') };
}
